import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { pageTransitionsViewTransition } from './pageTransitionsViewTransitionCompNode'
import { pageTransitionsDomApplier } from './pageTransitionsDomApplier'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'
import type { PageTransitionsCssFeature } from './pageTransitions.types'

export const pageTransitionsCssFeature: PageTransitionsCssFeature = {
	featureName: 'pageTransitions',
	experimentName: 'specs.thunderbolt.mpaViewTransitionsCssFeature',
	renderableNodes: { pageTransitionsViewTransition },
	intermediateNodes: { pageTransition: compInfoNodes.pageTransition },
	dataMaps: ['document_data'],
	domApplier: pageTransitionsDomApplier,
}

export const page: BindFeature = (bind) =>
	bind(CssFeatureSymbol).toConstantValue(pageTransitionsCssFeature)
